import { render, staticRenderFns } from "./AttenteResultats.vue?vue&type=template&id=75bc2f38&scoped=true"
import script from "./AttenteResultats.vue?vue&type=script&lang=js"
export * from "./AttenteResultats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bc2f38",
  null
  
)

export default component.exports